module.exports = __webpack_public_path__ + "img/send-button.d25b9a54.svg";